import { FC } from "react";
import { useRectangularSkeleton } from "./useRectangleSkeleton";
import { RectangularSkeletonProps } from "./types";
import classNames from "classnames";

const RectangularSkeleton: FC<RectangularSkeletonProps> = (props) => {
  const { style } = useRectangularSkeleton(props);
  return (
    <div
      style={style}
      className={classNames(
        "rounded-4 bg-fds-disable animate-pulse",
        props.className
      )}
    />
  );
};

export default RectangularSkeleton;
